export class MessagesService {
    constructor(httpService, messagesFactory) {
        this.httpService = httpService;
        this.messagesFactory = messagesFactory;
    }
    async save(message) {
        const response = await this.httpService.post('message', message);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al guardar el mensaje.');
        }
    }
    async getRoomMessages(roomId) {
        const response = await this.httpService.get(`room/${roomId}/messages`);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener los mensajes de sala.');
        }
        const content = await response.json();
        return content.map(({ id, roomId, enabled, text }) => this.messagesFactory.create(roomId, id, enabled, text));
    }
    async deleteMessage(messageId) {
        const response = await this.httpService.delete(`message/${messageId}`);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al eliminar el mensaje.');
        }
    }
}
